"use client"
/* */
const locales = {"de-DE": {  "progressBar.of": `von`,
},"en-US": {  "progressBar.of": `of`,
}};

export { locales as default };
//# sourceMappingURL=_.locale.json@162914df08c90e5e10d2f78b03d9d768.mjs.map
